import "./HelpForm.scss";
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const Help = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.message.length < 10) {
      setError("Message must be at least 10 characters long.");
      return;
    } 
    if (formData.subject.length < 5) {
      setError("Subject must be at least 5 characters long.");
      return;
    }
    if (formData.name.length < 3) {
      setError("Name must be at least 3 characters long.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setError("Email is invalid.");
      return;
    }
    if (formData.email.length < 5) {
      setError("Email must be at least 5 characters long.");
      return;
    }
    setError(null);
    setSuccess(false);
    try {
      const response = await axios.post("/help", formData); // Adjust the URL if needed
      console.log("Response:", response.data);
      setSuccess(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setError(error.response?.data?.error || "Something went wrong.");
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="help-container">
      <h2>Contact Form</h2>
      {success && toast.success("Message sent successfully!")}
      {error && <p className="error-msg">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="help-group">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />
        </div>

        <div className="help-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />
        </div>

        <div className="help-group">
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Enter subject"
            required
          />
        </div>

        <div className="help-group">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            style={{ resize: "vertical", width: "100%" }}
            rows="6"
            placeholder="Type your message here..."
            required
          />
        </div>

        <button type="submit">Submit</button>

       
      </form>
    </div>
  );
};

export default Help;
